<template>
    <div class="set_avatar">
        <navbar>
            <template #left>
                <span class="material-icons">arrow_back</span>
            </template>
            <template #title>
                {{ $t('user.t59') }}
            </template>
        </navbar>
        <div class="head">
            <img :src="headpic" alt="">
            <button class="btn" @click="settingAvatar()">
                {{ $t('user.t60') }}
            </button>
        </div>
        <div class="list">
            <div class="item" v-for="(item,index) in list" :key="item.url" @click="setAvatar(index,item.url)">
                <img :src="item.url" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'set_avatar',
    data() {
        return {
            headpic: '',
            index: 0,
            list: [
                {
                    url: require('@/assets/image/1.png'),
                },
                {
                    url: require('@/assets/image/2.png'),
                },
                {
                    url: require('@/assets/image/3.png'),
                },
                {
                    url: require('@/assets/image/4.png'),
                },
                {
                    url: require('@/assets/image/5.png'),
                },
                {
                    url: require('@/assets/image/6.png'),
                },
                {
                    url: require('@/assets/image/7.png'),
                },
                {
                    url: require('@/assets/image/8.png'),
                },
                {
                    url: require('@/assets/image/9.png'),
                },
                {
                    url: require('@/assets/image/10.png'),
                },
                {
                    url: require('@/assets/image/11.png'),
                },
                {
                    url: require('@/assets/image/12.png'),
                },
                {
                    url: require('@/assets/image/13.png'),
                },
                {
                    url: require('@/assets/image/14.png'),
                },
                {
                    url: require('@/assets/image/15.png'),
                },
            ],
            userinfo: JSON.parse(localStorage.getItem('userInfo')),
        }
    },
    created() {
        if (this.userinfo?.headpic) {
            this.headpic = this.list[this.userinfo.headpic].url
        }else{
            this.list.forEach((item, index) => {
                if (index === this.index) {
                    this.headpic = item.url
                }
            })
        }
    },
    methods: {
        setAvatar(idx,url) {
            this.index = idx
            this.headpic = url
        },
        settingAvatar() {
            this.$http.setheadimg({
                pic: this.index
            }).then(res => {
                if (res.code === 0) {
                    this.$toast.success({
                        message: res.info,
                        duration: 600
                    });
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 800);
                } else {
                    this.$toast.fail(res.info)
                }
            })

        }
    }
}
</script>
<style lang="less" scoped>
.set_avatar {
    // background-color: #fff !important;
    height: 100vh;

    .material-icons {}

    .head {
        background-size: 100%;
        text-align: center;
        padding: .4rem;
        // background-image: url('@/assets/image/head.png');
        background-color: #121212;

        img {
            width: 1.6rem;
            height: 1.6rem;
            border-radius: 50%;
        }

        .btn {
            border: .013333rem solid #fff;
            border-radius: .133333rem;
            color: #fff;
            line-height: .666667rem;
            width: 2.133333rem;
            display: block;
            margin: 0 auto;
            background-color: transparent;
            margin-top: .266667rem;
            font-size: .4rem;
        }
    }

    .list {
        // border-top: .266667rem solid #f2f2f2;
        display: flex;
        flex-wrap: wrap;

        .item {
            flex: 0 0 20%;
            padding: .266667rem;

            img {
                width: 100%;
                border-radius: 50%;
            }
        }
    }
}
::v-deep{
    .van-nav-bar__title{
        color: #fff !important;
    }
}
</style>
